import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Scrolls to top on every route change.
// For renter pages the scroll container is a fixed <main id="renter-main-scroll">
// rather than the window, so we target that element first and fall back to window.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const renterMain = document.getElementById('renter-main-scroll');
    if (renterMain) {
      renterMain.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
